import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { FormSwitch, FormTextField } from '../../../../../lib/components';
import { AddButton } from '../../shared/addButton';
import { CompanyForm, CompanyFormProps } from '../../shared/companyForm';

type Props = Omit<CompanyFormProps, 'children'>;

export const LocationDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();
  const params = useParams();

  return (
    <>
      <CompanyForm {...props}>
        <FormTextField
          label={t('employee:NAME')}
          placeholder={t('employee:NAME')}
          name="name"
          xs={12}
        />
        <FormSwitch name="active" label={t('employee:ACTIVE')} />
      </CompanyForm>
      {params.locationId === 'new' && (
        <Box marginTop={'1rem'}>
          <AddButton
            disabled={!props.formRef?.current?.dirty}
            onClick={() => props.formRef?.current?.handleSubmit()}
          />
        </Box>
      )}
    </>
  );
};
